import React from 'react';
import { TextAlign } from '../../../util/TextboxRef';
import { converter } from '../converter';
import styles from './StaticTextBox.module.scss';

export type StaticTextBox = {
  text: string;
  textAlign: TextAlign;
};

export const StaticTextBox: React.FC<StaticTextBox> = ({ text, textAlign }) => {
  return (
    <div
      className={styles.container}
      style={{ textAlign }}
      dangerouslySetInnerHTML={{
        __html: converter.makeHtml(text),
      }}
    />
  );
};
